import { render, staticRenderFns } from "./serviceAllowanceModal.vue?vue&type=template&id=1f88c880&scoped=true"
import script from "./serviceAllowanceModal.vue?vue&type=script&lang=js"
export * from "./serviceAllowanceModal.vue?vue&type=script&lang=js"
import style0 from "./serviceAllowanceModal.vue?vue&type=style&index=0&id=1f88c880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88c880",
  null
  
)

export default component.exports